import { render, staticRenderFns } from "./AgregarProductos.vue?vue&type=template&id=44e53f2b&scoped=true&"
import script from "./AgregarProductos.vue?vue&type=script&lang=js&"
export * from "./AgregarProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e53f2b",
  null
  
)

export default component.exports